require('mmenu-light')
require('bs-custom-file-input')
require('@fancyapps/fancybox')

var windowWidth
var sb
var headerH

  // breadcrumb mobile
;(function ($) {
  'use strict'

  $('.breadcrumb-item-expand').on('click', function () {
    $('.breadcrumb-item').addClass('visible')
  })
})($)

// show header on scroll down
;(function ($) {
  'use strict'

  windowWidth = $(window).width()

  if (windowWidth > 992) {
    function hasScrolled(lastScrollTop) {
      var $header, headerPinned, headerUnpinned, scroll, ht, hbt, body, scrollUp

      $header = $('#header__cloned')
      headerPinned = 'header--pinned'
      headerUnpinned = 'header--unpinned'
      body = $('body')
      scrollUp = 'scroll-up'

      scroll = $(window).scrollTop()
      ht = $header.outerHeight()
      hbt = 300

      if (scroll > lastScrollTop) {
        $header.addClass(headerUnpinned).removeClass(headerPinned)
        body.removeClass(scrollUp)
      } else {
        if (scroll <= hbt / 2) {
          $header.addClass(headerUnpinned).removeClass(headerPinned)
        } else if (scroll <= hbt + ht) {
          $header.addClass(headerUnpinned).removeClass(headerPinned)
        } else {
          $header.addClass(headerPinned).removeClass(headerUnpinned)
          body.addClass(scrollUp)
        }
      }

      return scroll
    }

    $(function () {
      var didScroll, lastScrollTop

      lastScrollTop = 0

      $('.headerSecondRow')
        .clone()
        .attr('id', 'header__cloned')
        .addClass('header-unpinned')
        .appendTo('body')

      __menuMain()

      $(window).scroll(function () {
        didScroll = true
      })

      setInterval(function () {
        if (didScroll) {
          lastScrollTop = hasScrolled(lastScrollTop)
          didScroll = false
        }
      }, 100)
    })
  }
})($)

// open globalsearch
$(function () {
  $('.globalSearch--open').on('click', function () {
    if ($(this).hasClass('searchOpen')) {
      $('.globalSearch--wrap').removeClass('visible').find('.tx-solr-q').val('')
      $('html').removeClass('popup--open')
      $(this).removeClass('searchOpen')
    } else {
      $('.globalSearch--wrap').addClass('visible').find('.tx-solr-q').focus()
      $('html').addClass('popup--open')
      $(this).addClass('searchOpen')

      if ($(window).width() < 991) {
        $('body').removeClass('mm-ocd-opened')
        $('.mm-ocd').removeClass('mm-ocd--open')
      }
    }
  })

  $('.globalSearch--close').on('click', function () {
    $('.globalSearch--wrap').removeClass('visible').find('.tx-solr-q').val('')
    $('html').removeClass('popup--open')
    $(this).removeClass('searchOpen')
  })

  $('.search--clear').on('click', function () {
    $(this).siblings('.tx-solr-q').val('').focus()
  })

  window.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      $('.globalSearch--wrap').removeClass('visible').find('.tx-solr-q').val('')
      $('html').removeClass('popup--open')
      $('.globalSearch--open').removeClass('searchOpen')
    }
  })

  if ($(window).width() < 991) {
    // mobile switch menu and search
    $('.mobileMenu--toggle').on('click', function () {
      if ($('.globalSearch--open').hasClass('searchOpen')) {
        $('.globalSearch--wrap')
          .removeClass('visible')
          .find('.tx-solr-q')
          .val('')
        $('html').removeClass('popup--open')
        $('.globalSearch--open').removeClass('searchOpen')
      }
    })
  }
})

// init mmenu light
$(function () {
  const node = document.querySelector('#mainMenuMobile')
  const menu = new MmenuLight(node, '(max-width: 991px)')

  const navigator = menu.navigation({
    // options
  })

  const drawer = menu.offcanvas({
    position: 'right',
  })

  document
    .querySelector('a[href="#mainMenuMobile"]')
    .addEventListener('click', evnt => {
      evnt.preventDefault()
      evnt.stopPropagation()
      if($('body').hasClass('mm-ocd-opened')) {
        drawer.close()
      } else {
        drawer.open()
      }
    })

  // move the metaMenu and language menu inside the mmenu
  if ($(window).width() < 991) {
    var $metaMenuMenu, $metaMenuBottom, $languageMenu, $logoutBtn, $menuBottom

    $metaMenuMenu = $('.metaMenu--mobileMenu').clone()
    $metaMenuBottom = $('.metaMenu--mobileBottom').clone()
    $languageMenu = $('.langSwitchMobile').clone()
    $logoutBtn = $('.dropdown-item-logout').clone().removeClass('dropdown-item')
    $menuBottom = $("<nav class='menuBottom'></nav>")

    $metaMenuMenu.prependTo('#mainMenuMobile > .mm-spn--open')

    $menuBottom.appendTo('.mm-ocd__content')
    $metaMenuBottom.appendTo('.menuBottom')
    $logoutBtn.appendTo('.menuBottom')
    $languageMenu.appendTo('.menuBottom')
  }
})

function stickyButton() {
  $(window).scroll(function () {
    if (parseInt(sb.top) - 13 < $(window).scrollTop()) {
      $('.stickyButton').addClass('sticky')
    }
    if (parseInt(sb.top) - (headerH + 13) > $(window).scrollTop()) {
      $('.stickyButton').removeClass('sticky')
    }
  })
}

function anchorMenu() {
  let anchorMenuMobileHeight = $('.frame-type-menu_section > .navbar').height();
  $(window).resize(function(){
    anchorMenuMobileHeight = $('.frame-type-menu_section > .navbar').height();
  });

  $(window).scroll(function () {
    if (parseInt(sb.top) < $(window).scrollTop()) {
      $('.frame-type-menu_section').height(anchorMenuMobileHeight);
      $('.frame-type-menu_section > .navbar').addClass('sticky')
    }
    if (parseInt(sb.top) - headerH > $(window).scrollTop()) {
      $('.frame-type-menu_section > .navbar').removeClass('sticky')
    }
  })
}

function anchorMenuMobile() {
  let anchorMenuMobileHeight = $('.frame-type-menu_section > .navbar').height();
  $(window).resize(function(){
    anchorMenuMobileHeight = $('.frame-type-menu_section > .navbar').height();
  });

  $(window).scroll(function () {
    if (parseInt(sb.top) - 68 < $(window).scrollTop()) {
      $('.frame-type-menu_section').height(anchorMenuMobileHeight);
      $('.frame-type-menu_section > .navbar').addClass('sticky')
    }
    if (parseInt(sb.top) - headerH > $(window).scrollTop()) {
      $('.frame-type-menu_section > .navbar').removeClass('sticky')
    }
  })
}

// init functions
$(function () {
  'use strict'

  $(document).ready(function () {
    __floatLabels()
  })

  __menuMain()
  __claimImagePosition()
  __accordionLinks()

  if ($('.stickyButton').length !== 0) {
    if ($(window).width() > 991) {
      sb = $('.stickyButton--place').offset()
      headerH = $('#header__cloned').height()
      headerH = parseInt(headerH)
      stickyButton()
    }

    $(window).resize(function () {
      if ($(window).width() > 991) {
        sb = $('.stickyButton--place').offset()
        headerH = $('#header__cloned').height()
        headerH = parseInt(headerH)
      }
    })
  }

  if ($('.frame-type-menu_section').length !== 0) {
    let offset = 125
    if ($(window).width() > 991) {
      sb = $('.frame-type-menu_section').offset()
      headerH = $('#header__cloned').height()
      headerH = parseInt(headerH)
      anchorMenu()
    } else {
      offset = 145
      sb = $('.frame-type-menu_section').offset()
      headerH = 68
      anchorMenuMobile()
    }
    $('body').scrollspy({target: '#menuSection', offset: offset})

    $(window).resize(function () {
      if ($(window).width() > 991) {
        sb = $('.frame-type-menu_section').offset()
        headerH = $('#header__cloned').height()
        headerH = parseInt(headerH)
      } else {
        sb = $('.frame-type-menu_section').offset()
        headerH = 68
      }
    })
  }

  if ($(window).width() > 767) {
    if ($('.frame-type-menu_sitemap_pages').length !== 0) {
      var buttonHeight
      buttonHeight = $('.contentMenu').height()

      $('.contentMenu--dropdown').css('top', buttonHeight)

      $(window).resize(function () {
        var buttonHeight
        buttonHeight = $('.contentMenu').height()

        $('.contentMenu--dropdown').css('top', buttonHeight)
      })
    }
  }
})

// glossary tooltips
;(function ($) {
  'use strict'

  // check if device has a touchscreen
  // needed for windows tablets / touchscreen devices
  // @returns {boolean}z
  function isTouchDevice() {
    if (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    ) {
      return true
    }

    return false
  }

  // if the device has a touchscreen
  if (isTouchDevice() === true && $(window).width() < 1200) {
    // on first click - open tooltip
    // on second click - open clicked link
    $('a.tooltip--link').on('click', function () {
      if ($(this).hasClass('toggled') === false) {
        // remove class toggled from all sibling elements
        $(this).siblings().removeClass('toggled')

        // add class toggled and show tooltip of clicked link
        $(this).addClass('toggled')

        // prevent link execution
        return false
      } else {
        // clicked second time
        return true
      }
    })
  }

  $('body').on('click', function (event) {
    if (
      $(event.target).parentsUntil('a.tooltip--link').last()[0].nodeName ===
      'HTML'
    ) {
      $('a.tooltip--link').removeClass('toggled')
    }
  })
})($)

// fancybox config
$(function () {
  'use strict'

  var defaultLocale

  defaultLocale = 'de'

  $.fancybox.defaults.lang = defaultLocale

  $.fancybox.defaults.btnTpl.close =
    '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11"><polygon points="11,10.276 6.223,5.499 10.998,0.724 10.275,0 5.5,4.775 0.725,0 0.002,0.724 4.777,5.499 0,10.276 0.723,11 5.5,6.223 10.277,11"/></svg>' +
    '</button>'

  $.fancybox.defaults.btnTpl.arrowLeft =
    '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
    '<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 29"><polygon points="16,1.9 3.4,14.5 16,27.1 14.2,29 0.8,15.4 0,14.5 0.8,13.6 14.2,0 "/></svg></div>' +
    '</button>'

  $.fancybox.defaults.btnTpl.arrowRight =
    '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
    '<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 29"><polygon points="1.8,0 15.2,13.6 16,14.5 15.2,15.4 1.8,29 0,27.1 12.6,14.5 0,1.9 "/></svg></div>' +
    '</button>'

  $('[data-fancybox]').fancybox({
    buttons: ['close'],
  })
})

/*
This function was originally used for giving object ids via placeholder ###count### for file attachments
It was then extended by the placeholder ###countfromone### for labels where you don't want to count from zero but from one
###countfromone### is also decremented if an attachment gets removed
 */
$(function () {
  'use strict'

  var countQuestion = 0
  if ($('.js-attachments').find('.countElement-question')) {
    countQuestion = $('.countElement-question').length
  }

  var i = 0
  var count = 1 + countQuestion

  // the replaced element is saved in this variable so it can be used if its removed (js-attachments-remove)
  var elem

  $(document).on('click', '.js-attachments-add', function () {
    var $el = $(this)
    var $attachments = $el.closest('.js-attachments')
    var $template = $attachments.find('.js-attachments-template')
    var html;
    if ($template.is("script")) {
      html = '' + $attachments.find('.js-attachments-template').text()
    } else {
      html = '' + $attachments.find('.js-attachments-template').html()
    }
    html = html.replace(/(###count###)/gm, ++i)
    if (html.includes('countfromone')) {
      html = html.replace(/(###countfromone###)/gm, ++count)
    }
    $attachments.find('.js-attachments-placeholder').append(html)
    elem = html

    // execute the form float label again
    __floatLabels()

    //Init parsley again with new fields
    var $form = $el.closest('form')
    console.log($form)
    $form.parsley().refresh()

    // file input, change name
    $('.custom-file-input').on('change', function () {
      var fileName = $(this).val().split('\\').pop()
      $(this).siblings('.custom-file-label').addClass('selected').html(fileName)
    })
  })

  // file input, change name
  $('.custom-file-input').on('change', function () {
    var fileName = $(this).val().split('\\').pop()
    $(this).siblings('.custom-file-label').addClass('selected').html(fileName)
  })

  $(document).on('click', '.js-attachments-remove', function () {
    $(this).closest('.js-attachment').remove()

    if (elem.includes('countfromone')) {
      count--
    }
  })
})

// toggle password
$(function () {
  'use strict'

  $('.toggle-password').click(function () {
    $(this).toggleClass('active')
    var input = $($(this).attr('toggle'))
    if (input.attr('type') == 'password') {
      input.attr('type', 'text')
    } else {
      input.attr('type', 'password')
    }
  })
})

// Ajax pagination
$(function () {
  'use strict'
  var CONTAINER_SELECTOR = '.js-ajax-pagination-container'
  $(CONTAINER_SELECTOR).on('click', '.f3-widget-paginator a', function (e) {
    e.preventDefault();
    var $el = $(this);
    var $container = $el.closest(CONTAINER_SELECTOR);
    var url = $el.data('href') || $el.attr('href');
    if ($el.data('loading')) return;
    $el.data('loading', true).addClass('is-loading');
    $.get(url, function (response) {
      var $innerContainer = $(response).find(CONTAINER_SELECTOR).html();
      $container.find('.f3-widget-paginator').replaceWith($innerContainer);
    }).always(function () {
      $el.data('loading', false).removeClass('is-loading');
    });
  });
});

// Ajax solr
$(function () {
  'use strict'
  const RESULTS_SELECTOR = '.js-results'
  const PLUGIN_SELECTOR = '.tx_solr'
  const LOADING_CLASS = 'is-loading'

  var ajaxifyUrl = function (url, type, record) {
    var glue = url.indexOf('?') === -1 ? '?' : '&'
    return url + glue + 'type=' + type + '&record=' + record
  }

  var AjaxSolrSearch = function (el, options) {
    this.el = el
    this.$el = $(el).closest(PLUGIN_SELECTOR)
    this.options = $.extend({}, $(el).data(), options)
    this._initialize()
  }

  AjaxSolrSearch.prototype._initialize = function () {
    var onSubmit = function (e) {
      e.preventDefault()
      var $form = $(e.target)
      var data = $form.serializeArray()
      data.push({name: 'type', value: this.options.type})
      data.push({name: 'record', value: this.options.record})
      this.search($form.attr('action'), data)
    }
    this.$el.on('submit', '.js-ajax-search form', onSubmit.bind(this))

    var onFilter = function (e) {
      e.preventDefault()
      var $el = $(e.target)
      var data = []
      data.push({name: 'type', value: this.options.type})
      data.push({name: 'record', value: this.options.record})
      this.search($el.data('href'), data)
    }
    this.$el.on(
      'change click',
      '.js-ajax-search [data-href]',
      onFilter.bind(this),
    )
  }

  AjaxSolrSearch.prototype.search = function (url, data, pushHistory = true) {
    var onBeforeSend = pushHistory
      ? function (jqXHR, settings) {
          try {
            var pushUrl = new URL(settings.url, window.location.origin)
            var params = new URLSearchParams(pushUrl.search)
            params.delete('type')
            params.delete('record')
            pushUrl.search = params.toString()
            history.pushState(
              {plugin: 'AjaxSolrSearch', url: url, data: data},
              null,
              pushUrl.toString(),
            )
          } catch (e) {
            // Ignore
          }
        }
      : $.noop

    $.ajax({
      url: url,
      data: data,
      context: this,
      beforeSend: onBeforeSend,
      success: function (response) {
        this.$el
          .removeClass(LOADING_CLASS)
          .html($(response).find(PLUGIN_SELECTOR).html())
      },
    })
  }

  $('.js-ajax-search')
    .slice(0, 1)
    .each(function () {
      var solr = new AjaxSolrSearch(this)
      window.addEventListener('popstate', function (e) {
        if (e.state && e.state.plugin === 'AjaxSolrSearch') {
          solr.search(e.state.url, e.state.data, false)
          $.each(e.state.data, function (i, value) {
            $('[name="' + value.name + '"]').val(value.value)
          })
        }
      })
    })

  $(PLUGIN_SELECTOR).on('click', '.solr-pagination a', function (e) {
    e.preventDefault()
    var $el = $(this)
    var $container = $el.closest(RESULTS_SELECTOR)
    var type = $container.data('type')
    var record = $container.data('record')
    var url = $el.attr('href')
    $container.addClass(LOADING_CLASS)
    $.post(url, {type: type, record: record},function (response) {
      $container
        .removeClass(LOADING_CLASS)
        .find('.solr-pagination')
        .replaceWith($(response).find(RESULTS_SELECTOR).html())
    })
  })
})

// Ajax form
$(function () {
  'use strict'
  var LOADING_CLASS = 'is-loading'
  $(document).on('submit', 'form[data-action]', function (e) {
    e.preventDefault()
    var $form = $(this)
    var data = $form.serialize()
    var $target = $($form.data('target'))
    if (!$target.length) {
      throw new Error('No target defined')
    }
    $target.addClass(LOADING_CLASS)
    var $inputs = $form.find('input:enabled,textarea:enabled,select:enabled')
    $inputs.prop('disabled', true)
    $.ajax({
      url: $form.data('action'),
      method: $form.attr('method'),
      data: data,
      success: function (data) {
        $target.html(data)
      },
      always: function () {
        $target.removeClass(LOADING_CLASS)
        $inputs.prop('disabled', false)
      },
    })
  })
})

// Use ajax for unsubscribe to prevent redirecting to topic (default behavior fo typo3_forum).
$(function () {
  'use strict'

  $('.tx-typo3forum-pi1').on('click', '.js-unsubscribe', function (event) {
    event.preventDefault()
    var $el = $(this)
    $el
      .closest('.extensionDefault--list-box-wrap')
      .fadeOut('fast', function () {
        $.get($el.attr('href'), function () {
          location.reload()
        })
        $el.remove()
      })
  })
})

// anchor links
$(function () {
  'use strict'

  var id

  function scrolltoAnchor(id) {
    if (id !== '' && $(id).length !== 0) {

      const navHeight = $('.frame-type-menu_section .navbar').height() || 0;
      const desktopOffset = $(id).offset().top - $(window).scrollTop() < 0 ? 120 : 40; // check up or down scroll = hidden main nav
      const offset = $(window).width() < 991 ? 85 : desktopOffset;

      $('html, body')
      .stop(true, true)
      .animate(
        {
          scrollTop: $(id).offset().top - (navHeight + offset),
        },
        1000,
      )
    }
  }

  // if menu item is clicked, highlight and scroll to anchor element
  $(
    '.page .frame-type-menu_section a, .anchorMenu a, .page .frame-type-text a',
  ).on('click', function (event) {
    var id
    // scroll to active element
    id = this.hash

    scrolltoAnchor(id)
  })

  $(window).scrollTop(0)

  id = $(location).attr('hash')
  scrolltoAnchor(id)
})

// forum topic close
$(function () {
  $('.topicClose--open').on('click', function () {
    $('.topicClose--wrap').addClass('visible')
  })

  $('.topicClose--close').on('click', function () {
    $('.topicClose--wrap').removeClass('visible')
  })
})

// textblock extend
$(function () {
  $('.textblock--collapsed-extend').on('click', function () {
    var textblockHeight = $('.textblock--collapsed-inner').height()

    $('.textblock--collapsed').css('height', textblockHeight + 30)
    $(this).hide()
  })
})

function __floatLabels() {
  var thisInput, inputField

  inputField = $('.input > .form-control')

  inputField.focus(function () {
    thisInput = $(this)
    $("label[for='" + thisInput.attr('id') + "']").addClass('animate-label')
  })

  inputField.blur(function () {
    thisInput = $(this)
    if (thisInput.val() == '') {
      $("label[for='" + thisInput.attr('id') + "']").removeClass(
        'animate-label',
      )
    }
  })

  $('.input').each(function () {
    var val = $(this).find('.form-control').val()
    if (val != '') {
      $(this).find('.control-label-inside').addClass('animate-label')
    }
  })
}

function __menuMain() {
  $('.mainMenu > ul > li.sub').on('click', function () {
    if (
      $(this).hasClass('toggled') === false &&
      $(this).children('.mainSub').length > 0
    ) {
      // remove class toggled from all sibling elements and hide navigation
      $(this).siblings().removeClass('toggled')

      // add class toggled and show subnavigation of clicked menu point
      $(this).addClass('toggled')

      if ($('.menuSecondWrap > ul > li').hasClass('toggledSub')) {
        var heightSub = $('.menuSecondWrap > ul > li.toggledSub')
          .children('ul')
          .height()
        $('.menuSecondWrap').css('min-height', heightSub + 62)
      }

      $('.menuSub--close').addClass('visible')

      return false
    } else {
      return true
    }
  })

  $('.mainMenu .menuSecondWrap > ul > li').on('click', function () {
    if (
      $(this).hasClass('toggledSub') === false &&
      $(this).children('ul').length > 0
    ) {
      // remove class toggled from all sibling elements and hide navigation
      $(this).siblings().removeClass('toggledSub')

      // add class toggled and show subnavigation of clicked menu point
      $(this).addClass('toggledSub')

      var heightSub = $(this).children('ul').height()
      $('.menuSecondWrap').css('min-height', heightSub + 62)

      return false
    } else {
      return true
    }
  })

  $('.menuSub--close').on('click', function () {
    $('.menuSub--close').removeClass('visible')
    $('.mainMenu > ul > li').removeClass('toggled')
  })

  $('body').on('click', function (event) {
    if (
      $(event.target).parentsUntil('.mainMenu').last()[0].nodeName === 'HTML'
    ) {
      $('.mainMenu ul li').removeClass('toggled')
      $('.menuSub--close').removeClass('visible')
    }
  })
}

function __claimImagePosition() {
  var claimImageId, breadcrumb, claimTextRteImageId

  claimImageId = 'claim--textImage'
  claimTextRteImageId = 'claim--textRteImage'
  breadcrumb = $('.breadcrumbWrap')

  if (document.getElementById(claimImageId) !== null) {
    if ($(window).width() < 767) {
      breadcrumb.insertAfter('#claim--textImage')
    } else {
      breadcrumb.addClass('breadcrumb--maxWidth col-md-6')
    }
  } else if (document.getElementById(claimTextRteImageId) !== null) {
    if ($(window).width() < 767) {
      breadcrumb.insertAfter('#claim--textRteImage .claim--image')
    } else {
      breadcrumb.addClass('breadcrumb--maxWidth col-md-6')
    }
  } else {
    return true
  }
}

function __accordionLinks() {
  $('.link-internal').on('click', function () {
    var link = $(this).attr('href')
    openAcccordionOnLink(link)
  })
  const hashLink = window.location.hash
  if (!hashLink) return
  openAcccordionOnLink(hashLink)
}

function openAcccordionOnLink(id) {
  const elem = document.querySelector(id)
  if (!elem || !elem.classList.contains('card-header')) return
  const collapseBtn = elem.querySelector('[data-toggle]')
  if (!collapseBtn) return
  const matchingCollapse = collapseBtn.dataset.target
  const collapseEl = document.querySelector(matchingCollapse)
  if (!collapseEl) return
  $(collapseEl).collapse('show')
}

// Prevent sending forms multiple times (double clicks)
$(function () {
  'use strict'

  $('.tx-typo3forum-pi1').on('submit', 'form[name="post"]', function () {
    $(this).find('[type="submit"]').prop('disabled', true)
  })
})

// Form autosave and autload functions
$(function () {
  'use strict'

  $('form[data-autoload]').each(function () {
    var $form = $(this)
    var url = $form.data('autoload')
    $.get(
      url,
      function (data) {
        if (Array.isArray(data)) {
          data.forEach(function (element) {
            var $el = $form.find('[name="' + element.name + '"]')
            $el.val(element.value)
          })
        }
      },
      'json',
    ).always(function () {
      var delay
      $form.on('change', 'input,select,textarea', function (e) {
        if (delay) {
          clearTimeout(delay)
        }
        var $form = $(this).closest('form')
        var url = $form.data('autosave')
        var data = JSON.stringify(
          $form.serializeArray().filter(function (input) {
            return input.name.indexOf('[__') === -1
          }),
        )
        delay = setTimeout(function () {
          // In case of autofill, throttle requests
          $.post(url, {'tx_isvetsearch_pi1[data]': data}, function () {})
          delay = null
        }, 100)
      })
    })
  })
})

// activate tooltip
$(function () {
  $('[data-toggle="tooltip"]').tooltip({
    html: true,
  })
})

// rss feed
$(function () {
  $('.btn--load-more-wrap button').on('click', function () {
    var $list = $(this).closest('.js-rss-activate');
    var limit = parseInt($list.data('limit'), 10) || 10;
    $list.find('.js-rssrow[hidden]').slice(0, limit).removeAttr('hidden');
    if ($list.find('.js-rssrow[hidden]').length === 0) {
      $(this).hide();
    }
  });
})

$(function () {
  $('a.js-history-back').on('click', function (e) {
    if (
      document.referrer &&
      new URL(document.referrer).origin === window.location.origin &&
      document.referrer !== window.location.href
    ) {
      e.preventDefault()
      window.history.back()
    }
  })
})

// sets css variable to expand content to full width
function _calculateScrollbarWidth() {
  document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
}
// recalculate on resize
window.addEventListener('resize', _calculateScrollbarWidth, false);
// recalculate on dom load
document.addEventListener('DOMContentLoaded', _calculateScrollbarWidth, false); 
// recalculate on load (assets loaded as well)
window.addEventListener('load', _calculateScrollbarWidth);
